import styled from 'styled-components';

export const CheckboxLabelContainer = styled.div`
  display: flex;
  width: 500px;
  cursor: pointer;
  left: 200px;
  top: 0;
  position: absolute;
`;

export const VytalCheckboxLabelContainer = styled.div`
  cursor: pointer;
  display: flex;
`;

export const CheckboxLabel = styled.span`
  margin-left: 0.5em;
  vertical-align: middle;
  ${(props) =>
    props.vytalStyle
      ? `
    color: white; 
  `
      : ''}
`;

export const CheckBoxHelpText = styled.span`
  opacity: 0.65;
`;

export const ExtraName = styled.div`
  display: inline-block;
`;
export const InnerDraggableContainer = styled.div`
  position: relative;
  display: inline-block;
`;
